var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Back(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18.6042C15.9965 18.4614 15.9377 18.3257 15.8361 18.2267L9.28616 11.5778L15.8361 4.92887C15.8873 4.87845 15.9279 4.81813 15.9557 4.75148C15.9835 4.68482 15.9978 4.61319 15.9978 4.54082C15.9977 4.43318 15.9661 4.32799 15.9068 4.23872C15.8476 4.14945 15.7634 4.08015 15.6652 4.03969C15.5669 3.99923 15.459 3.98945 15.3552 4.01161C15.2515 4.03376 15.1566 4.08683 15.0827 4.16404L8.156 11.1954C8.05611 11.2968 8 11.4344 8 11.5778C8 11.7212 8.05611 11.8588 8.156 11.9602L15.0827 18.9916C15.157 19.0702 15.2531 19.1242 15.3582 19.1465C15.4633 19.1688 15.5727 19.1583 15.6718 19.1164C15.771 19.0745 15.8553 19.0032 15.9139 18.9118C15.9724 18.8204 16.0024 18.7132 15.9999 18.6042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Back);
export default __webpack_public_path__ + "static/media/icn_24x24_back.cb3a4a8d8725da708169a2aee78de57e.svg";
export { ForwardRef as ReactComponent };